module.exports = __webpack_public_path__ + "img/Newbie_Bow_02_Mage.f8aad62b.png";